export default __webpack_public_path__ + "static/media/cancel-icon-grey.086eb95e.svg";